module.exports = __webpack_public_path__ + "img/part7.9189850c.png";